/* eslint-disable */
/* eslint-disable no-nested-ternary */
import Graphic from "@arcgis/core/Graphic";
/**
 *
 * @param {array} data - array of data with geometry
 * @param {object} view - view object
 * @param {object} graphicsLayer - graphics layer object
 */

export default function handleZoom(
  data,
  view,
  graphicsLayer,
  options = { color: [242, 250, 47, 1], width: 2 }
) {
  const { color, width } = options;
  const polygonMarker = {
    type: "simple-fill",
    outline: { width, color },
  };
  const centroidData = data.map(
    (item) =>
      new Graphic({
        attributes: { ...item },
        geometry: item.geometry,
        symbol: polygonMarker,
      })
  );
  graphicsLayer?.removeAll();
  graphicsLayer?.addMany(centroidData);
  view.goTo(centroidData);
}
